import ko from 'knockout';
import _ from 'underscore';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class BaseTargetViewModel {
  constructor({
    exclusionType = 'site',
    exclusions = '',
    exclusionType2String = {},
    entitySeparator = '',
    campaignExclusions = '',
  } = {}) {
    this.errors = ko.observableArray();

    this.exclusions = ko.observable(exclusions || '');

    this.numbersExcluded = ko.computed(() => {
      const val = _.isEmpty(this.exclusions()) ? '' : this.exclusions().replace(entitySeparator, '');
      const count = _.size(_.compact(val.split('\n')));

      return i18n.get(exclusionType2String[exclusionType].numberExcluded).replace('{0}', count);
    });

    this.campaignExclusions = ko.observable(campaignExclusions || '');
    this.isExpanded = ko.observable(false);

    this.getExclusions = ko.computed(() => {
      return this.exclusions();
    });
  }
}
